import { createContext, useContext } from 'react';

export const ThemeContext = createContext({ toggleTheme: () => {}, theme: false });

export const useTheme = () => {
  return useContext(ThemeContext);
};
